<template>
  <div class="user">
    <el-dropdown trigger="click">
      <div class="el-dropdown-link">
        Profile <i class="el-icon-arrow-down el-icon--right" />
        <div class="user-info">
          <div class="user-timezone">
            {{ currentTimezone }}
          </div>
        </div>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item>
          <router-link
              id="profile-button"
              :to="{ name: 'profile' }">
            View Profile
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item
            v-if="isAdmin"
            divided>
          <router-link
              id="settings-button"
              :to="{ name: 'settings' }">
            Settings
          </router-link>
        </el-dropdown-item>
        <el-dropdown-item divided>
          <a
              id="logout-button"
              @click.prevent="takeMeOut()">
            <i class="el-icon-circle-close-outline" /> Logout
          </a>
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { createNamespacedHelpers as h } from "vuex";
const { mapGetters: uiGetters, mapActions: uiActions } = h("ui");
const { mapActions: authActions, mapGetters: authGetters } = h("auth");

export default {
  name: "UserOptions",
  computed: {
    ...uiGetters(["currentTimezone"]),
    ...authGetters(["user"]),
    isAdmin() {
      return this.$store.getters["auth/isAdmin"];
    },
  },
  methods: {
    ...uiActions(["setLoading"]),
    ...authActions(["logOut"]),
    takeMeOut() {
      this.$confirm("This will log you out. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      })
        .then(() => {
          this.setLoading(true);
          this.logOut()
            .then(() => {
              this.$router.push({ path: "/login" });
              this.setLoading(false);
            })
            .catch((error) => {
              console.error("Could not logout");
            })
            .finally(() => {
              this.setLoading(false);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Logout canceled",
          });
        });
    },
  },
};
</script>

<style lang="scss">
.el-dropdown-link {
  cursor: pointer;
  font-size: 14px;
  text-align: right;
}
#logout-button {
  color: #f56c6c;
  margin-left: 10px;
  text-align: center;
}
#profile-button {
  text-align: center;
  text-decoration: none;
}
#settings-button {
  text-align: center;
  color: grey;
  text-decoration: none;
  margin-left: 15px;
}
.user-info {
  padding: 0;
  margin-top: 3px;
  height: 15px;
  line-height: 15px;
}
.user-info .user-timezone {
  color: #999;
  font-size: 13px;
  float: left;
}
.user-info .user-language {
  color: #999;
  font-size: 13px;
  float: right;
}
</style>
